import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { BASE_URLL } from "../../../api/AxiosBaseUrl";

const TrainingRegistration = () => {
  const location = useLocation();
  const stateData = location.state || {};

  const [formData, setFormData] = useState({
    training_name: "",
    training_description: "",
    training_date: "",
    training_duration: "",
    candidate_name: "",
    candidate_email: "",
    candidate_phone: "",
    training_id: "T_id_01",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorMessages, setErrorMessages] = useState({});

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    setFormData((prev) => ({
      ...prev,
      training_date: today,
      training_duration: "6 months",
      training_name: stateData.training_name || "",
      training_description: stateData.training_description || "",
    }));
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "candidate_phone") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Clear field-specific error on change
    setErrorMessages((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const data = formData;
    const errors = {};
    const fieldOrder = [
      "candidate_name",
      "candidate_email",
      "candidate_phone",
      "training_name",
      "training_description",
      "training_date",
      "training_duration",
    ];

    for (const field of fieldOrder) {
      switch (field) {
        case "candidate_name":
          if (!data.candidate_name || !/^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(data.candidate_name)) {
            errors.candidate_name = "Name must contain only letters and spaces.";
          }
          break;
        case "candidate_email":
          if (
            !data.candidate_email ||
            !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(data.candidate_email)
          ) {
            errors.candidate_email = "Enter a valid email address.";
          }
          break;
        case "candidate_phone":
          if (!data.candidate_phone || !/^\d{10}$/.test(data.candidate_phone)) {
            errors.candidate_phone = "Phone must be exactly 10 digits.";
          }
          break;
        case "training_name":
          if (!data.training_name) {
            errors.training_name = "Please select training.";
          }
          break;
        case "training_description":
          if (!data.training_description || data.training_description.length < 10) {
            errors.training_description = "Description must be at least 10 characters.";
          }
          break;
        case "training_date":
          if (!data.training_date) {
            errors.training_date = "Date is required.";
          }
          break;
        case "training_duration":
          if (!data.training_duration) {
            errors.training_duration = "Duration is required.";
          }
          break;
        default:
          break;
      }
    }

    setErrorMessages(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccessMsg("");
    setErrorMsg("");

    const isValid = validateForm();
    if (!isValid) return;

    setLoading(true);

    try {
      const payload = {
        training_name: formData.training_name,
        training_description: formData.training_description,
        training_date: formData.training_date,
        training_duration: formData.training_duration,
        candidate_name: formData.candidate_name,
        candidate_email: formData.candidate_email,
        candidate_phone: formData.candidate_phone,
        Training_id: "1",
      };

      const response = await axios.post(`${BASE_URLL}/api4/training_user/`, payload);
      console.log("Training res:", response.data);

      setSuccessMsg("Training registration successful!");
      setFormData({
        training_name: "",
        training_description: "",
        training_date: new Date().toISOString().slice(0, 10),
        training_duration: "6 months",
        candidate_name: "",
        candidate_email: "",
        candidate_phone: "",
        training_id: "1",
      });
      setErrorMessages({});
    } catch (error) {
      console.error(error);
      const data = error.response?.data || {};

      const fieldErrors = {};
      if (data.candidate_email) {
        fieldErrors.candidate_email = data.candidate_email[0];
        alert("Email already exists. Please use a different email.");
      }
      if (data.candidate_phone) {
        fieldErrors.candidate_phone = data.candidate_phone[0];
        alert("Phone number already exists. Please use a different phone number.");
      }

      if (Object.keys(fieldErrors).length > 0) {
        setErrorMessages((prev) => ({ ...prev, ...fieldErrors }));
      } else if (data.error) {
        setErrorMsg(data.error);
      } else {
        setErrorMsg("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className=" edit-main">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="p-4 shadow-lg">
            <h4 className="text-center mb-4">Training Registration</h4>

            {successMsg && <Alert variant="success">{successMsg}</Alert>}
            {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Training Name</Form.Label>
                <Form.Select
                  name="training_name"
                  value={formData.training_name}
                  onChange={handleChange}
                  isInvalid={!!errorMessages.training_name}
                  required
                >
                  <option value="">-- Select Training --</option>
                  <option value="Python Bootcamp">Python Bootcamp</option>
                  <option value="React Training Program">React Training Program</option>
                  <option value="Machine Learning">Machine Learning</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errorMessages.training_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Training Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="training_description"
                  value={formData.training_description}
                  onChange={handleChange}
                  isInvalid={!!errorMessages.training_description}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.training_description}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Training Date</Form.Label>
                <Form.Control
                  type="date"
                  name="training_date"
                  value={formData.training_date}
                  onChange={handleChange}
                  isInvalid={!!errorMessages.training_date}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.training_date}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Training Duration</Form.Label>
                <Form.Control
                  type="text"
                  name="training_duration"
                  value={formData.training_duration}
                  onChange={handleChange}
                  placeholder="e.g. 6 months"
                  isInvalid={!!errorMessages.training_duration}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.training_duration}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="candidate_name"
                  value={formData.candidate_name}
                  onChange={handleChange}
                  isInvalid={!!errorMessages.candidate_name}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.candidate_name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="candidate_email"
                  value={formData.candidate_email}
                  onChange={handleChange}
                  isInvalid={!!errorMessages.candidate_email}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.candidate_email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="candidate_phone"
                  value={formData.candidate_phone}
                  onChange={handleChange}
                  placeholder="10-digit phone number"
                  isInvalid={!!errorMessages.candidate_phone}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessages.candidate_phone}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center">
                <Button type="submit" variant="primary" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" /> Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TrainingRegistration;
